<template>
<div v-if="filteredLatestNews" class="headline-panel" id="headline-panel">
    <figure class="effect-julia">
        <img v-if="filteredLatestNews.featured_image" v-bind:src="filteredLatestNews.featured_image" alt="img22">
        <img v-else src="http://lorempixel.com/640/480/" alt="aperçu">
        <figcaption>
            <h3><span>{{filteredLatestNews.title}}</span></h3>
            <div>
                <p>par {{filteredLatestNews.user.username}}</p>
            </div>
            <router-link :to="detaillUrl">View more</router-link>
        </figcaption>
    </figure>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import spinner from '../common/spinner.vue'

export default {
  name: 'headline',
  components: {
    spinner
  },
  computed:
  {
    ...mapGetters([
      'filteredLatestNews'
    ]),
    detaillUrl: function () {
      return '/news/' + this.filteredLatestNews.id
    }
  },
  created () {
    store.dispatch('getNewsPage', 1)
  },
  data () {
    return {
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
figure{
	margin: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
}

figure {
	position: relative;
	overflow: hidden;
	text-align: center;
	cursor: pointer;
}

figure figcaption {
	padding: 2em 2em 2em 0;
	text-transform: uppercase;
	font-size: 1.25em;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
}

figure figcaption::before,
figure figcaption::after {
	pointer-events: none;
}

figure figcaption,
figure figcaption > a {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

/* Anchor will cover the whole item by default */
/* For some effects it will show as a button */
figure figcaption > a {
	z-index: 1000;
	text-indent: 200%;
	white-space: nowrap;
	font-size: 0;
	opacity: 0;
}

figure h3,
figure p {
	margin: 0;
  font-size: 1.2em;
}

figure p {
	letter-spacing: 1px;
	font-size: 0.9em;
}

figure img{
    width: 100%
}

/*---------------*/
/***** Julia *****/
/*---------------*/

figure.effect-julia figcaption h3{
	background-color: rgba(255,255,255,0.9);
	color : rgba(85,85,86,1);
	min-width: 50%;
	padding:0.1em 0.5em;
	text-align : right;
	position: relative;
}

figure.effect-julia img {
	-webkit-transition: opacity 1s, -webkit-transform 1s;
	transition: opacity 1s, transform 1s;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
}

figure.effect-julia figcaption {
	text-align: left;
	margin : 0;
}

figure.effect-julia p {
	margin: 0.25em 0 0.25em;
	padding: 0.4em 1em;
	background: rgba(255,255,255,0.9);
	text-transform: none;
	font-size: 0.8em;
    color : rgba(85,85,86,1);

	-webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
	transition: opacity 0.35s, transform 0.5s;
	-webkit-transform: translate3d(-2000px,0,0);
	transform: translate3d(-2000px,0,0);
	text-align : right;
}

figure.effect-julia p:first-child {
	-webkit-transition-delay: 0.15s;
	transition-delay: 0.15s;
}

figure.effect-julia p:nth-of-type(2) {
	-webkit-transition-delay: 0.1s;
	transition-delay: 0.1s;
}

figure.effect-julia p:nth-of-type(3) {
	-webkit-transition-delay: 0.05s;
	transition-delay: 0.05s;
}

figure.effect-julia:hover p:first-child {
	-webkit-transition-delay: 0s;
	transition-delay: 0s;
}

figure.effect-julia:hover p:nth-of-type(2) {
	-webkit-transition-delay: 0.05s;
	transition-delay: 0.05s;
}

figure.effect-julia:hover p:nth-of-type(3) {
	-webkit-transition-delay: 0.1s;
	transition-delay: 0.1s;
}

figure.effect-julia:hover img {
	opacity: 0.4;
	-webkit-transform: scale3d(1.1,1.1,1);
	transform: scale3d(1.1,1.1,1);
}

figure.effect-julia:hover p {
	opacity: 1;
	-webkit-transform: translate3d(0,0,0);
	transform: translate3d(0,0,0);
}

.headline-panel{
    background-color: rgba(255,255,255,0.1);
    padding: 0rem;
    margin: 1rem 0rem 1rem 0rem;
}
</style>



// WEBPACK FOOTER //
// headline.vue?512c2195